import React, { useState, useEffect } from "react";
import {Button, Modal,Typography,Table, TableHead, TableCell, TableRow,TableBody, Card, CardContent} from "@material-ui/core";
import axios from "../../api";
import Swal from "sweetalert2";
import HelperFormatData from "../../HelperFormatData";
import $ from "jquery";
function EncaminharPaciente({ title , sendPassword }) {

    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);

    //m[etodo par afechar modal
    const handleClose = () => {
        setOpen(false);
    };

    //m[etodo para abrior modal e j[a fazer o preload das informa;óes neceszsarios sobre senhas em triagem
    const handleOpen = () => {
        const token = localStorage.getItem('token');
        setOpen(true);

        axios.get("/senha/triagem", { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => {
                setData(response.data.data); // Verifique se a matriz está em response.data.data
            })
            .catch((error) => {
                console.error(error);
                Swal.fire("Error", "Failed to fetch data", "error");
            });
    };

    //pega o senha id e manda como call back
    const handleButtonClick = async (rowId, rowName) => {
        handleClose();
        const confirmResult = await Swal.fire({
            title: 'Você tem certeza?',
            text:
                'Você tem certeza que deseja encaminhar esse paciente para o consultório? Uma vez enviado, essa modificação não poderá ser desfeita.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Encaminhar',
            cancelButtonText: 'Cancelar',
        });

        if (confirmResult.isConfirmed) {
            sendPassword(rowId, rowName)
        }
    };

    //metodo para adicionar a tabulacao de informa;o9esd com base na lid do jquery datatables
    useEffect(() => {
        // Verifique se o DataTable já foi inicializado na tabela
        const table = $('#encaminhar').DataTable();
        if ($.fn.DataTable.isDataTable('#encaminhar')) {
            table.destroy();
        }

        // Inicialize o DataTable aqui
        $(document).ready(function() {
            $('#encaminhar').DataTable({
                language: {
                    url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                },
                deferRender: true,
                destroy: true, // adicione essa opção
                lengthChange: false // adicione essa opção para ocultar a seleção de quantidade de resultados
            });
        });
    }, [data]);


    return (
        <div>
            <Button variant="contained" id={"info"} size="small" onClick={handleOpen}>
                <i className="fas fa-check"></i> Verificar listagem
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "54%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        backgroundColor: "white",
                    }}
                >
                    <br/>
                    <Card>
                        <CardContent>
                            <Typography variant="h5">{title}</Typography>
                            <Table  id="encaminhar">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>#Protocolo</b></TableCell>
                                        <TableCell>Nome</TableCell>
                                        <TableCell>Senha atribuída</TableCell>
                                        <TableCell>Necessidade especial</TableCell>
                                        <TableCell>Necessidade especial</TableCell>
                                        <TableCell>Açóes</TableCell>
                                        {/* Adicione mais colunas conforme necessário */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell>{row.id}</TableCell>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.senha}</TableCell>
                                            <TableCell>{(row.tipo_deficiencia === null) ? 'Não' : row.tipo_deficiencia}</TableCell>
                                            <TableCell>{HelperFormatData(row.updated_at)}</TableCell>
                                            <TableCell>
                                                <Button variant="contained" id="success" size="small" onClick={() => handleButtonClick(row.id, row.name)}>
                                                    <i className="fas fa-arrow-right"></i> Encaminhar paciente
                                                </Button>
                                            </TableCell>
                                            {/* Adicione mais colunas conforme necessário */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </div>
            </Modal>
        </div>
    );
}

export default EncaminharPaciente;
